import '../../styles/components/_gameRecap.css';

export const GameRecap = ({ gameData }) => {
  const getIcon = (rank) => {
    switch (rank) {
      case 1:
        return '🥇';
      case 2:
        return '🥈';
      case 3:
        return '🥉';
      default:
        return '💩';
    }
  };

  const formatCurrency = (value) => {
    const numValue = Number(value);
    const absValue = Math.abs(numValue).toFixed(2);
    return numValue < 0 ? `-$${absValue}` : `+$${absValue}`;
  };

  const formatDate = (dateString) => {
    const match = dateString.match(/Date\((\d+),(\d+),(\d+)\)/);
    if (!match) return dateString;

    const [_, year, month, day] = match;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${monthNames[parseInt(month)]} ${parseInt(day)}, ${year}`;
  };

  // Default placeholder rankings
  const defaultRankings = [
    { rank: 1, name: null, winnings: null },
    { rank: 2, name: null, winnings: null },
    { rank: 3, name: null, winnings: null },
    { rank: 4, name: null, winnings: null }
  ];

  const rankings = gameData?.rankings || defaultRankings;
  const date = gameData?.date ? formatDate(gameData.date) : 'Loading...';
  const location = gameData?.location || 'Loading...';

  const winner = rankings[0];
  const second = rankings[1];
  const third = rankings[2];
  const loser = rankings[3];

  return (
    <div className="last-game-summary">
      <h2 className="last-game-title">Last Game's Recap</h2>
      <p className="last-game-date">{date} @ {location}</p>

      <div className="podium-container">
        {/* Second Place - Left */}
        <div className="podium-place podium-second">
          <div className="place-name">{second.name || '...'}</div>
          <div className="podium-pillar pillar-second">
            <div className="rank-emoji">{getIcon(2)}</div>
            {second.winnings !== null && (
              <div className={`winnings ${second.winnings < 0 ? 'text-red' : 'text-green'}`}>
                {formatCurrency(second.winnings)}
              </div>
            )}
          </div>
        </div>

        {/* First Place - Middle */}
        <div className="podium-place podium-first">
          <div className="place-name">{winner.name || '...'}</div>
          <div className="podium-pillar pillar-first">
            <div className="rank-emoji">{getIcon(1)}</div>
            {winner.winnings !== null && (
              <div className={`winnings ${winner.winnings < 0 ? 'text-red' : 'text-green'}`}>
                {formatCurrency(winner.winnings)}
              </div>
            )}
          </div>
        </div>

        {/* Third Place - Right */}
        <div className="podium-place podium-third">
          <div className="place-name">{third.name || '...'}</div>
          <div className="podium-pillar pillar-third">
            <div className="rank-emoji">{getIcon(3)}</div>
            {third.winnings !== null && (
              <div className={`winnings ${third.winnings < 0 ? 'text-red' : 'text-green'}`}>
                {formatCurrency(third.winnings)}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Loser - Below Podium */}
      <div className="loser-container">
        <div className="rank-emoji">{getIcon(4)}</div>
        <div className="loser-name">{loser.name || '...'}</div>
        {loser.winnings !== null && (
          <div className={`winnings ${loser.winnings < 0 ? 'text-red' : 'text-green'}`}>
            {formatCurrency(loser.winnings)}
          </div>
        )}
      </div>
    </div>
  );
};